<template>
  <div class="order-content">
    <h3 class="account-sub-title d-none d-md-block">
      <i class="sicon-folder-alt align-middle mr-3"></i>
      {{ translations.myFiles }}
    </h3>
    <div class="order-table-container order-table-with-content">
      <table class="table table-order text-left">
        <thead>
          <tr>
            <th>{{ translations.ord }}.</th>
            <th class="order-id">{{ translations.title }}</th>
            <th class="order-status">{{ translations.documentName }}</th>
            <th class="order-date">{{ translations.date }}</th>
            <th class="order-action">{{ translations.actions }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="files.length === 0">
            <td class="text-center p-0" colspan="5">
              <p class="mb-5 mt-5">{{ translations.folderIsEmpty }}.</p>
            </td>
          </tr>
          <tr class="pending-order" v-for="(item, index) in files" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>
                {{ item.fileName }}
            </td>
            <td>
              {{ format(item.createdDate) || 'N/A' }}
            </td>
            <td class="order-actions">
              <a
                target="_blank"
                :href="`${baseUrl}/${item.contentUrl}`"
                @click.prevent="downloadItem({
                  url: `${baseUrl}/${item.contentUrl}`,
                  label: item.fileName
                })">
                <i class="fa fa-file-pdf"></i> {{ translations.download }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination :action="actionName" />
      <hr class="mt-0 mb-3 pb-2" v-if="files.length === 0" />
      <!-- <router-link :to="{ name: 'NewDocument' }" class="btn btn-primary">
        {{ translations.newDocument }}
      </router-link> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { format } from 'date-fns';

import config from '@/config';
import { pager, translations } from '@/mixins';
import Pagination from '@/components/shared/Pagination.vue';

export default {
  name: 'Orders',
  mixins: [pager, translations],
  components: {
    Pagination,
  },
  data() {
    return {
      actionName: 'getUserFiles',
    };
  },
  computed: {
    files() {
      return this.$store.getters.getUserFiles;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  methods: {
    format(dateString) {
      return format(new Date(dateString), 'dd.MM.yyyy H:mm');
    },
    downloadItem({ url, label }) {
      axios.get(url, { responseType: 'blob' }).then((response) => {
        const blob = new Blob([response.data]);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = label;
        link.click();
        URL.revokeObjectURL(link.href);
      }).catch(() => {
        this.$toast.error('Tražena datoteka nije pronađena');
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
};
</script>
